import { useFormikContext } from "formik";
import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerItemData } from "@design-system/Picker/Picker.types";
import { DescriptionListItem } from "@design-system/DescriptionList/DescriptionList";
import taskStyles from "@components/drawers/TaskDrawerFields.module.scss";
import {
    ASSIGNEE_ROLE_LABEL,
    ASSIGNEE_ROLE_OPTIONS,
    NO_ASSIGNEE_ROLE_VALUE,
} from "../closeTemplateTasksDrawer.constants";
import type { TemplateTaskDetailsValues } from "./templateTaskDetails.schema";

const ASSIGNEE_ROLE_ITEMS: Array<PickerItemData<string>> = [
    { value: NO_ASSIGNEE_ROLE_VALUE, label: "No role" },
    ...ASSIGNEE_ROLE_OPTIONS.map((role) => ({
        value: role,
        label: ASSIGNEE_ROLE_LABEL[role],
    })),
];

export const AssigneeRoleField = () => {
    const formik = useFormikContext<TemplateTaskDetailsValues>();

    return (
        <DescriptionListItem label="Role">
            <div className={taskStyles.detailSelectWrapper}>
                <Picker.Select
                    items={ASSIGNEE_ROLE_ITEMS}
                    value={formik.values.assigneeRole ?? NO_ASSIGNEE_ROLE_VALUE}
                    onValueChange={(value) => {
                        if (!value) {
                            return;
                        }
                        void formik.setFieldValue(
                            "assigneeRole",
                            value === NO_ASSIGNEE_ROLE_VALUE ? null : value,
                        );
                    }}
                    trigger={
                        <Picker.Button
                            variant="primary"
                            className={taskStyles.detailSelectTrigger}
                        />
                    }
                />
            </div>
        </DescriptionListItem>
    );
};
